import { StandardEvents } from '@shopify/events';

let pendingProduct = null;
let activeDialog = null;
let previouslyFocused = null;
let frame = 0;

const shownProducts = new Set();

function showPendingOffer() {
  if (!pendingProduct || activeDialog) return;

  const templates = Array.from(
    document.querySelectorAll('template[data-jewellery-offer]')
  );

  const template = templates.find((node) =>
    node.dataset.productIds.split(',').includes(pendingProduct)
  );

  if (!template) return;

  const productId = pendingProduct;
  pendingProduct = null;

  if (shownProducts.has(productId)) return;

  const dialog = template.content.firstElementChild.cloneNode(true);

  previouslyFocused = document.activeElement;
  document.body.append(dialog);
  activeDialog = dialog;

  dialog.addEventListener(
    'close',
    () => {
      dialog.remove();
      activeDialog = null;

      if (
        previouslyFocused instanceof HTMLElement &&
        previouslyFocused.isConnected
      ) {
        previouslyFocused.focus();
      }
    },
    { once: true }
  );

  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;

    const rect = dialog.getBoundingClientRect();

    const outside =
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom;

    if (outside) dialog.close();
  });

  try {
    dialog.showModal();
    shownProducts.add(productId);
  } catch (error) {
    dialog.remove();
    activeDialog = null;
    console.warn('Rekommendationen kunde inte öppnas.', error);
  }
}

function queueCheck() {
  if (!pendingProduct || frame) return;

  frame = requestAnimationFrame(() => {
    frame = 0;
    showPendingOffer();
  });
}

new MutationObserver(queueCheck).observe(document.body, {
  childList: true,
  subtree: true,
});

document.addEventListener(
  StandardEvents.cartLinesUpdate,
  async (event) => {
    pendingProduct = null;

    if (event.action !== 'add' || !event.promise) return;

    try {
      const result = await event.promise;
      const detail = result?.detail;

      if (detail?.didError || !detail?.productId) return;

      const productId = String(detail.productId);

      if (shownProducts.has(productId)) return;

      const sourceDialog =
        event.target instanceof Element
          ? event.target.closest('dialog')
          : null;

      if (sourceDialog?.open) {
        sourceDialog.addEventListener(
          'close',
          () => {
            pendingProduct = productId;
            queueCheck();

            setTimeout(() => {
              if (pendingProduct === productId) {
                pendingProduct = null;
              }
            }, 5000);
          },
          { once: true }
        );
      } else {
        pendingProduct = productId;
        queueCheck();

        setTimeout(() => {
          if (pendingProduct === productId) {
            pendingProduct = null;
          }
        }, 5000);
      }
    } catch (error) {
      pendingProduct = null;
    }
  }
);
